import api from "./api";

/**
 * @service liquidationBatchService
 * @description Servicio para gestión de lotes de liquidación
 */
const endpoint = "/liquidation-batches";

export default {
  /**
   * @method getAll
   * @description Listar lotes con filtros opcionales
   */
  getAll(params) {
    return api.get(endpoint, { params }).then(({ data }) => data);
  },

  /**
   * @method getInconsistencies
   * @description Listar lotes con inconsistencias para bandeja de revisión
   */
  getInconsistencies(params) {
    return api
      .get(`${endpoint}/inconsistencies`, { params })
      .then(({ data }) => data);
  },

  /**
   * @method getById
   * @description Detalle de un lote con items populados
   */
  getById(id) {
    return api.get(`${endpoint}/${id}`).then(({ data }) => data);
  },

  /**
   * @method create
   * @description Crear nuevo lote
   */
  create(payload) {
    return api.post(endpoint, payload).then(({ data }) => data);
  },

  /**
   * @method resolve
   * @description Resolver inconsistencia — approve | reject | request_invoice
   */
  resolve(id, action, resolutionNote) {
    return api
      .put(`${endpoint}/${id}/resolve`, { action, resolutionNote })
      .then(({ data }) => data);
  },

  /**
   * @method getInvoiceFileUrl
   * @description Obtener signed URL del PDF de factura
   */
  getInvoiceFileUrl(id) {
    return api.get(`${endpoint}/${id}/invoice-file`).then(({ data }) => data);
  },

  /**
   * @method uploadInvoiceFile
   * @description Subir PDF de factura del lote
   */
  uploadInvoiceFile(id, file) {
    const formData = new FormData();
    formData.append("file", file);
    return api
      .put(`${endpoint}/${id}/invoice-file`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then(({ data }) => data);
  },
};
